import { Component } from '@theme/component';

 class RelatedArticlesList extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.handleLoadMore = this.handleLoadMore.bind(this);
    this.refs.viewMoreNext?.addEventListener('click', this.handleLoadMore);
  }

  disconnectedCallback() {
    this.refs.viewMoreNext?.removeEventListener('click', this.handleLoadMore);
  }

  handleLoadMore(e) {
    e.preventDefault();
    this.loadMore();
  }

  async loadMore() {
    const sectionId = this.getAttribute('section-id');
    if (!sectionId) return;

    const url = `${window.location.pathname}?sections=${sectionId}`;

    try {
      const response = await fetch(url);
      const sectionsData = await response.json();
      
      const sectionHtml = sectionsData[sectionId];
      if (!sectionHtml) throw new Error('Section HTML not found in response');

      this.revealItems();

    } catch (error) {
      console.error('Section Rendering API error:', error);
      this.revealItems();
    }
  }

  revealItems() {
    const hiddenItems = Array.from(this.querySelectorAll('.artie-related-articles__item.is-hidden'));
    const nextBatch = hiddenItems.slice(0, 6);
    
    nextBatch.forEach(item => item.classList.remove('is-hidden'));

    if (hiddenItems.length <= 6) {
      if (this.refs.viewMoreNext) {
        this.refs.viewMoreNext.style.display = 'none';
      }
    }
  }
}

if (!customElements.get('related-articles-list')) {
  customElements.define('related-articles-list', RelatedArticlesList);
}